export default __webpack_public_path__ + "static/media/pic65.76a2639c.jpg";